import React, { useRef, useMemo } from "react";
import PageBody from "Common/Custom/PageBody";
import { HeadingOne } from "Common/Custom/HeadingOne";
import LaundryInvoice from "./Component/LaundryInvoice";
import useFetchAllDataByID from "Hooks/useFetchAllDataById";
import { useParams } from "react-router-dom";
import Spinner from "Common/Globle/Spinner";
import { GetAllinfoById } from "adminApi/LaundryApi/Laundry";
import { useReactToPrint } from "react-to-print";

const ViewLaundry = () => {
  const { id } = useParams();
  const printRef = useRef(null);

  const requestParams = useMemo(() => (id ? { id } : null), [id]);

  const { data: laundryInvoice, loading } =
    useFetchAllDataByID(GetAllinfoById, requestParams);

  const handlePrint = useReactToPrint({
    contentRef: printRef, //  CORRECT FOR v3+
    documentTitle: `Laundry-Invoice-${laundryInvoice?.invoice_no}`,
  });

  return (
    <>
      {loading && <Spinner isSpinner />}

      <PageBody card headerchildren={<HeadingOne>Laundry Invoice</HeadingOne>}>
        {/* Print Button */}
        <div className="d-flex justify-content-end mb-3">
          <button
            className="btn btn-primary"
            onClick={handlePrint}
            disabled={loading || !laundryInvoice}
          >
             Print Invoice
          </button>
        </div>

        {/* Printable Invoice */}
        <div
          ref={printRef}
          className="print-container"
          style={{ display: laundryInvoice ? "block" : "none" }}
        >
          {laundryInvoice && <LaundryInvoice data={laundryInvoice} />}
        </div>
      </PageBody>
    </>
  );
};

export default ViewLaundry;
